import React from "react";
import "./AboutMeApp.css";
import profileImage from "./assets/headshot.png";

const AboutMeApp = () => {
  return (
    <div className="about-me-app">
      <div className="scrapbook-page">
        {/* Photo Section */}
        <div className="photo-section">
          <div className="polaroid-frame">
            <div className="photo-wrapper">
              <img
                src={profileImage}
                alt="Kenny Thai"
                className="profile-photo"
              />
            </div>
            <div className="photo-caption">
              <span className="caption-text">Kenny Thai</span>
            </div>
          </div>
          <div className="decorative-tape tape-1"></div>
          <div className="decorative-tape tape-2"></div>
        </div>

        {/* Info Section */}
        <div className="info-section">
          <div className="header-with-icon">
            <h1 className="about-title">About Me</h1>
          </div>

          <div className="bio-text">
            <p className="intro-paragraph">
              My focus was solely on A+'s until I came across C++!
              <br />
              <br />
              Hello! I'm Kenny, a software engineer who loves building solutions
              to real-world problems. Outside of coding, you'll find me trying
              local cafes, watching shows, running, or swimming.
            </p>

            <div className="social-links-container">
              <a
                href="https://www.linkedin.com/in/thaikenny/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <svg
                  className="social-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                </svg>
                <span>LinkedIn</span>
              </a>

              <a
                href="https://github.com/kennythai2003"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <svg
                  className="social-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z" />
                </svg>
                <span>GitHub</span>
              </a>

              <a
                href="mailto:kennythai021403@gmail.com"
                className="social-link"
              >
                <svg
                  className="social-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                <span>Email</span>
              </a>

              <a
                href="/resume.pdf"
                download
                className="social-link resume-button"
              >
                <svg
                  className="social-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                </svg>
                <span>Resume</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMeApp;
